import { render, staticRenderFns } from "./ActifFilter.vue?vue&type=template&id=67037ac8&"
import script from "./ActifFilter.vue?vue&type=script&lang=js&"
export * from "./ActifFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports